import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import US from "../assets/images/EU.svg";
import NGN from "../assets/images/ngnnigeria.jpg";
import EU from "../assets/images/usds.svg";
import GB from "../assets/images/GB.svg";
import KES from "../assets/images/KES.svg";
import USDC from "../assets/images/USDC.svg";
import USDT from "../assets/images/USDT.svg";
import Button from "./ui/button";
import { Check, ChevronDown } from "lucide-react";
import { cn } from "../libs/utils";
export const  currencyList = [
  { _id: "ngn-fb", text: "NGN", img: NGN, name: "Naira" },
  { _id: "gbp-fb", text: "GBP", img: GB, name: "Pound Sterling" },
  { _id: "eur-fb", text: "EUR", img: US, name: "Euro" },
  { _id: "kes-fb", text: "KES", img: KES, name: "Kenyan Shilling" },
  { _id: "usd-fb", text: "USD", img: EU, name: "US Dollars" },
  { _id: "usdc-fb", text: "USDC", img: USDC, name: "USDC" },
  { _id: "usdt-fb", text: "USDT", img: USDT, name: "USDT" },
];

const CurrencyDropdown = ({ selected, onSelect }) => {
  const currentCurrency = currencyList.find((currency) => currency.text === selected);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-2 bg-white rounded-md outline-none focus-within:outline-0">
        <Button variant="ghost" size="sm" className="flex items-center gap-1 p-0">
          <img src={currentCurrency?.img} alt={`${selected} flag`} className="size-5" />
          <ChevronDown size={12} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-white rounded-[8px] gap-1 flex flex-col shadow-lg border outline-0 focus-within:outline-0 focus-visible:outline-none focus-visible:outline-0 w-48">
        {currencyList?.map(({ text, img }, index) => {
          const isSelectedItem = selected === text;
          return (
            <DropdownMenuItem
              key={index}
              className={cn(
                "flex items-center justify-between hover:bg-primary-50 cursor-pointer !rounded-[8px] p-2",
                isSelectedItem ? "bg-primary-50" : ""
              )}
              onClick={() => onSelect?.(text)} // Fixed: Pass the actual text value
            >
              <div className="flex items-center gap-2">
                <img src={img} alt={`${text} flag`} className="w-5 h-4" />
                <span>{text}</span>
              </div>
              {isSelectedItem && <Check className="w-4 h-4 text-primary" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CurrencyDropdown;
